import React, { useState } from 'react'

function CuttingEdge() {
   const [activeFeature, setActiveFeature] = useState('indBasicFeatures')

   const basicFeatures = [
      'Sign Up & Login',
      'Audio Streaming',
      'Push Notifications',
      'Classroom Forum',
      'Document Sharing',
      'Lecture Scheduling',
      'Video Conferencing',
      'Easy-to-Use Interface',
      'Integrated Leaderboards',
      'Assignments & Homework Management'
   ]

   const advancedFeatures = [
      'Payment Integration',
      'Performance Tracker',
      'Gamification & Rewards',
      'Multi-Language Support',
      'AI-Powered Chat Support',
      'Data Analytics & Reporting',
      'AI-Powered Personalization',
      'Online & Offline Learning Mode',
      'Progress Tracking Dashboard',
      'Interactive Graphics & AR Integration'
   ]

   const handleFeatureClick = (targetId) => {
      setActiveFeature(targetId)
   }

   return (
      <section className="industries-bg-image">
         <div className="container">
            <div className="add-full-border">
               <h2 className="text-center cs-text-secondary tech_title section_heading_title mb-2">
                  Cutting-Edge Features You Get in Our
                  <br/>
                    Modern Education Software Development
               </h2>
               <p className="section_desc cs-text-secondary mb-0">
                  Benzatine’s education software development solutions are
                  equipped with powerful, intuitive features designed to
                  streamline learning processes, enhance administrative
                  efficiency, and boost student engagement. From essential
                  functionalities for seamless operations to advanced tools for
                  data-driven insights and personalized learning experiences, we
                  deliver comprehensive software solutions that cater to the
                  evolving demands of the education sector.
               </p>

               <div className="ind-features-section">
                  <div className="ind-features-btn-group">
                     <div 
                        className={`ind-features-btn ${activeFeature === 'indBasicFeatures' ? 'active' : ''}`}
                        id="indBasicFeatures"
                        onClick={() => handleFeatureClick('indBasicFeatures')}
                     >
                        Basic Features
                     </div>
                     <div 
                        className={`ind-features-btn ${activeFeature === 'indAdvancedFeatures' ? 'active' : ''}`}
                        id="indAdvancedFeatures"
                        onClick={() => handleFeatureClick('indAdvancedFeatures')}
                     >
                        Advanced Features
                     </div>
                  </div>
                  <div className="row ind-add-gap">
                     <div className="col-lg-6">
                        <div
                           className={`ind-features-wrap ${activeFeature === 'indBasicFeatures' ? 'active' : ''}`}
                           data-target="indBasicFeatures"
                        >
                           {basicFeatures.map((feature, index) => (
                              <div key={index} className="ind-features-list">
                                 <p>{String(index + 1).padStart(2, '0')}. &nbsp;{feature}</p>
                              </div>
                           ))}
                        </div>
                     </div>
                     <div className="col-lg-6">
                        <div
                           className={`ind-features-wrap ${activeFeature === 'indAdvancedFeatures' ? 'active' : ''}`}
                           data-target="indAdvancedFeatures"
                        >
                           {advancedFeatures.map((feature, index) => (
                              <div key={index} className="ind-features-list">
                                 <p>{String(index + 1).padStart(2, '0')}. &nbsp;{feature}</p>
                              </div>
                           ))}
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </section>
   )
}

export default CuttingEdge
